import store from '../redux/store';

let timezone = 'UTC';
try{
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
}catch(err) {
  timezone = 'UTC'
}
timezone = timezone || 'UTC';

function getBaseHost() {      
  return process.env.REACT_APP_API_URL;
}

function getUserData() {      
  return store.getState().user.data;
}

function getTimezone() {      
  return timezone;
}

function checkResponseStatus(response) {      
  const statusCode = response.response.status;  
  if (statusCode === 401){
    window.location.href = '/auth/pre-check/';
  }
  return timezone;
}


export default {
  getBaseHost,
  getUserData,
  getTimezone,
  checkResponseStatus
}